// extracted by mini-css-extract-plugin
export default {"header":"Header_header__AgKdq","companyName":"Header_companyName__yIMyg","logo":"Header_logo__pHne4"};